import * as PIXI from "pixi.js";
import {GameService} from "../services/GameService";
import {Events} from "./events";
import {Modal} from "../components/modals/Modal";
import { ApiServiceClass } from "../core/api/ApiService";
import {bgMusic, clickMusic, loseMusic, openCardsMusic, scratchMusic, winMusic} from "./sound";

export const loader = new PIXI.Loader();
export const app = new PIXI.Application();
export const ticker = PIXI.Ticker.shared;
export const events = new Events();
export const gameData = new GameService();
export const modal = new Modal();
export const ApiService = new ApiServiceClass();

export const bgSound = bgMusic();
export const clickSound = clickMusic();
export const scratchSound = scratchMusic();
export const openCardsSound = openCardsMusic();
export const loseSound = loseMusic();
export const winSound = winMusic();
globalThis.__PIXI_APP__ = app;

export const iconSizes = {
    mobile: {
        questionIcon: {
            size: 28,
            positionLeft: 18
        },
        soundIcon: {
            size: 28,
            positionLeft: 70
        },
        balance: {
            positionRight: 165,
            baseWidth: 97
        },
    },
    web: {
        questionIcon: {
            size: 38.5,
            positionLeft: 170
        },
        soundIcon: {
            size: 38.5,
            positionLeft: 234
        },
        balance: {
            positionRight: 18,
            baseWidth: 78
        },
    }
}